import { render, staticRenderFns } from "./PartnerCurrentDetail.vue?vue&type=template&id=7996fea2&scoped=true&"
import script from "./PartnerCurrentDetail.vue?vue&type=script&lang=js&"
export * from "./PartnerCurrentDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7996fea2",
  null
  
)

export default component.exports